<template>
    <div class="template-works">
        <div class="page-intro"><h1>模板创作</h1><p>选择模板，快速开始你的花艺与园林作品</p></div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="数字插花" name="flower"></el-tab-pane>
            <el-tab-pane label="现代花艺 / 园林景观" name="landscape"></el-tab-pane>
            <el-tab-pane label="花艺环境 · 2D" name="environment"></el-tab-pane>
        </el-tabs>
        <template v-if="activeName === 'flower'">
            <div class="template-filters"><el-input v-model.trim="keyword" clearable prefix-icon="el-icon-search" placeholder="搜索当前页模板名称"></el-input></div>
            <div class="template-grid">
                <article class="template-card" v-for="item in visibleList" :key="item.id">
                    <div class="template-image" @click="toEditDetail(item)"><img :src="item.coverImage | imgFormat" :alt="item.name" /></div>
                    <div class="template-meta"><h2>{{ item.name }}</h2><p>{{ item.userName }} · {{ item.likeCount || 0 }} 次喜欢</p>
                        <div class="template-actions"><button type="button" @click="toEditDetail(item)">开始创作</button><button type="button" @click="share(item)">分享</button><button type="button" @click="viewMaterials(item)">查看素材</button></div>
                    </div>
                </article>
            </div>
            <div class="template-empty" v-if="!visibleList.length">暂无匹配的模板</div>
        </template>
        <div v-else class="template-empty">当前分类的模板作品将在接口接入后显示</div>
        <div class="ls_flex_center mt30" v-if="activeName === 'flower'">
            <el-pagination
                v-show="total > 0"
                :current-page="params.pageIndex"
                :page-sizes="[10, 15, 20, 25]"
                :page-size="params.pageSize"
                :total="total"
                background
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    data() {
        return {
            value1: false,
            activeName: 'flower',
            keyword: '',

            list: [],
            params: {
                pageIndex: 1,
                pageSize: 10,
                type: 1,
            },
            total: 0,
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        visibleList() {
            const keyword = this.keyword.toLowerCase();
            return keyword ? this.list.filter(item => (item.name || '').toLowerCase().includes(keyword)) : this.list;
        },
    },
    methods: {
        getList() {
            this.$ajax
                .post('/product/expand/queryList', this.params)
                .then(res => {
                    this.list = res.list;
                    this.total = res.total;
                });
        },
        handleSizeChange(val) {
            this.params.pageIndex = 1;
            this.params.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.params.pageIndex = val;
            this.getList();
        },
        toEditDetail(item) {
            window.open(
                this.$editAddr +
                    '?productExpandId=' +
                    item.id +
                    `&authToken=${localStorage.getItem('authToken')}`
            );

            // 点赞
            this.$ajax
                .post('/product/expand/like', {
                    productExpandId: item.id,
                    likeType: 1,
                })
                .then(() => {
                    setTimeout(this.getList, 1000);
                });
        },
        // 分享
        share(item) {
            this.$ajax
                .get('/product/createShareCode', {
                    params: { id: item.productId },
                })
                .then(res => {
                    this.$confirm(
                        <div>
                            <img
                                class='w300 h300'
                                src={Vue.filter('imgFormat')(res.data)}
                            />
                            <div class='mt25 fz18'>
                                微信扫一扫，三维作品发送手机
                            </div>
                        </div>,
                        '',
                        {
                            showCancelButton: false,
                            showConfirmButton: false,
                            dangerouslyUseHTMLString: true,
                            center: true,
                        }
                    );
                });
        },
        // 查看用料
        viewMaterials(item) {
            let dom = '';
            if (!item.useMaterials) {
                this.$message.warning('暂无用料信息');
                return;
            }

            item.useMaterials.map(item => {
                dom += `<div class="ls_flex ls_aic">
                    <span class="lh26 fz14 cf21 mr10">⬤</span>
                    <span class="lh26 fz14">
                        ${item.materialName} x${item.count}
                    </span>
                </div>`;
            });

            this.$confirm(`<div>${dom}</div>`, '用料详情', {
                showCancelButton: false,
                showConfirmButton: false,
                dangerouslyUseHTMLString: true,
                width: '400px',
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.page-intro { margin-bottom: 22px; }
.page-intro h1 { margin: 0; color: #18201c; font-size: 28px; font-weight: 700; }
.page-intro p { margin: 8px 0 0; color: #89948d; font-size: 14px; }
.template-filters { display: flex; padding: 16px 18px; margin: 6px 0 18px; border: 1px solid #e8eee9; border-radius: 16px; background: #fff; }
.template-filters .el-input { width: 290px; }
.template-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 20px; }
.template-card { overflow: hidden; border: 1px solid #e8eee9; border-radius: 20px; background: #fff; box-shadow: 0 8px 24px rgba(33,79,53,.05); }
.template-image { height: 210px; display: grid; place-items: center; cursor: pointer; background: linear-gradient(135deg, #e7f3eb, #f8e9e8); }
.template-image img { width: 100%; height: 100%; object-fit: contain; }
.template-meta { padding: 18px; }
.template-meta h2 { margin: 0 0 7px; font-size: 17px; font-weight: 650; }
.template-meta p { color: #89948d; font-size: 13px; }
.template-actions { display: flex; flex-wrap: wrap; gap: 14px; margin-top: 18px; }
.template-actions button { color: #21965b; font-size: 13px; cursor: pointer; }
.template-actions button:hover { text-decoration: underline; }
.template-empty { padding: 80px 20px; color: #89948d; text-align: center; font-size: 14px; }
@media (max-width: 760px) { .template-filters .el-input { width: 100%; } }
</style>
